import React from 'react'
import { withMap } from './MapContext'
import { createPortal } from 'react-dom'
import L from 'leaflet'

class Popup extends React.Component {
  constructor(props) {
    super(props)

    this.popup = L.popup({
      closeButton: false,
      closeOnEscapeKey: false,
      closeOnClick: false,
      className: this.getClassNames()
    })
      .setLatLng(this.props.position)

    this.popups = L.featureGroup([this.popup]).addTo(this.props.map)
    this.popups.eachLayer(function(layer) {
      layer.openPopup()
    })
  }

  getClassNames() {
    const classNames = ['sch-popup']

    if(this.props.active)     classNames.push('is-active')
    if(this.props.blue)       classNames.push('is-blue')
    if(this.props.red)       classNames.push('is-red')
    if(this.props.textCenter) classNames.push('has-text-center')
    if(this.props.onClick)    classNames.push('is-link')
    if(this.props.info)       classNames.push('is-info')
    if(this.props.image)       classNames.push('is-image')
    if(this.props.pinOnLeft)  classNames.push('pin-on-left')
    if(this.props.pinOnRight) classNames.push('pin-on-right')

    return classNames.join(' ')
  }

  componentDidMount() {
    this.popup.update()

    if(this.props.onClick) {
      this.popup._contentNode.addEventListener('click', this.props.onClick)
    }
  }

  componentDidUpdate(props) {
    if(props.active !== this.props.active) {
      if(this.props.active) {
        this.popup._container.classList.add('is-active')
      } else {
        this.popup._container.classList.remove('is-active')
      }
    }
  }

  componentWillUnmount() {
    if(this.props.onClick) {
      this.popup._contentNode.removeEventListener('click', this.props.onClick)
    }
    // this.leafletElement.off('move', this.onViewportChange)
    // this.leafletElement.off('moveend', this.onViewportChanged)
    this.popups.removeLayer(this.popup)
  }

  render() {
    if(!this.popup._contentNode) return null

    return createPortal(this.props.children, this.popup._contentNode)
  }
}

export default withMap(Popup)



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/components/Popup.js